import api from '@/api/company'
import { errorHandler } from '../exports/error_management'

import { StorageCache } from '../exports/dataStorage'

const companyKey = 'ams-company-settings-key'

const getParsedData = (key, configurations, valueType = 'string') => {
    try {
        const data = configurations.find(x => x.key == key)
        switch (valueType) {
            case 'array':
            case 'object':
                return JSON.parse(data.text_value)
            case 'string':
                return data.text_value
            case 'int':
                return parseInt(data.text_value, 10)
        }
    } catch (err) {
        switch (valueType) {
            case 'array':
                return []
            case 'object':
                return {}
            case 'string':
                return null
            case 'int':
                return null
        }
    }
}

const state = {
    settings: {},
    ///keys
    settingKeys: {
        assetFrequencyKey: 'AssetFrequencySettingsKey',
        unitMeasureKey: 'UnitMeasureSettingsKey',
        companyNoteKey: 'companyNotesReferenceSettings',
        orderHeaderKey: 'orderHeaderUploadSettings',
        orderDetailKey: 'orderDetailsUploadSettings',
        defaultRoleKey: 'defaultRoleForNotificationSettings',
        customerUploadKey: 'customerUploadSettings',
        inventoryUploadKey: 'inventoryUploadSettings',
        templateHeaderKey: 'templateHeaderUploadSettings',
        templateDetailKey: 'templateDetailsUploadSettings',
        assetUploadKey: 'assetUploadSettings',
        inventoryUsageKey: 'inventoryUsageSettings',
        taskTypeKey: 'taskTypeSettings',
        crmsettingsKey: 'crmsettingkey',
        emailPartsKey: 'emailPartsKey',
        companyPolicyKey: 'companyPolicyKey',
        inventoryTransferKey: "inventoryTransferKey001",
        quickbookRealmIdKey: "quickbookRealmIdKey001",
        userUploadKey: 'bulkusersUploadSettings',
        billPaymentEmailSendersKey: 'BillPaymentEmailSendersSettingsKey',
        billPaymentEmailSubjectLinesKey: 'BillPaymentEmailSubjectLinesSettingsKey',
        orderUploadKey : 'orderUploadSettings',
        WorkflowUploadKey : 'WorkflowUploadSettings',
        RolesUploadKey : 'RolesUploadSettings',
        WorkflowTemplateUploadKey : 'WorkflowTemplateUploadSettings',
        UserRosterUploadKey : 'UserRosterUploadSettings',
        ActivityTypeUploadKey : 'ActivityTypeUploadSettings',
        ItemTypeUploadKey : 'ItemTypeUploadSettings',
        TargetsUploadKey : 'TargetsUploadSettings',
    },
}

const parseConfigurations = ({ commit, state }, configuration, key) => {
    console.log('mutate configuration data', configuration)
    const settings = { ...(state.settings || {}) }
    settings.configurations = settings.configurations || []
    let idx = settings.configurations.findIndex(x => x.key === key)
    if (idx === -1) idx = settings.configurations.length
    if (configuration) settings.configurations.splice(idx, 1, configuration)
    else settings.configurations.splice(idx, 1)
    console.log('settings', settings)
    const storageCache = new StorageCache(companyKey)
    storageCache.set(settings)
    commit('SET_SETTINGS', settings)
}

const getters = {
    configurations(state) {
        console.log(
            'state.settings.configurations',
            state.settings.configurations
        )
        return state.settings.configurations
    },

    assetFrequencies(state) {
        return getParsedData(
            state.settingKeys.assetFrequencyKey,
            state.settings.configurations,
            'array'
        )
    },

    unitMeasures(state) {
        return getParsedData(
            state.settingKeys.unitMeasureKey,
            state.settings.configurations,
            'array'
        )
    },

    billPaymentEmailSenders(state) {
        return getParsedData(
            state.settingKeys.billPaymentEmailSendersKey,
            state.settings.configurations,
            'array'
        )
    },


    billPaymentEmailSubjectLines(state) {
        return getParsedData(
            state.settingKeys.billPaymentEmailSubjectLinesKey,
            state.settings.configurations,
            'array'
        )
    },

    companyNotes(state) {
        return getParsedData(
            state.settingKeys.companyNoteKey,
            state.settings.configurations,
            'array'
        )
    },

    defaultRole(state) {
        return getParsedData(
            state.settingKeys.defaultRoleKey,
            state.settings.configurations,
            'int'
        )
    },

    taskTypeValue(state) {
        return getParsedData(
            state.settingKeys.taskTypeKey,
            state.settings.configurations,
            'object'
        )
    },

    emailPartsValue(state) {
        return getParsedData(
            state.settingKeys.emailPartsKey,
            state.settings.configurations,
            'object'
        )
    },

    crmSettingValue(state) {
        return getParsedData(
            state.settingKeys.crmsettingsKey,
            state.settings.configurations,
            'object'
        )
    },
    
    companyPolicyValue(state) {
        return getParsedData(
            state.settingKeys.companyPolicyKey,
            state.settings.configurations,
            'object'
        )
    },

    customerUploadSettings(state) {
        return getParsedData(
            state.settingKeys.customerUploadKey,
            state.settings.configurations,
            'object'
        )
    },

    assetUploadSettings(state) {
        return getParsedData(
            state.settingKeys.assetUploadKey,
            state.settings.configurations,
            'object'
        )
    },

    /*  customerUploadSettings(state) {
        return getParsedData(
            state.settingKeys.customerUploadKey,
            state.settings.configurations,
            'object'
        )
    }, */
}

const mutations = {
    SET_SETTINGS(state, settings) {
        console.log('mutate settings data', settings)
        state.settings = settings
    },
}

const actions = {
    async fetch({ commit }) {
        try {
            const storageCache = new StorageCache(companyKey)
            const { is_valid, value } = storageCache.getObject()
            if (!is_valid) {
              
                const result = await api.fetch()
                console.log('fetch company data-new', result)
                const data = result.data.success.data
                storageCache.set(data)
                Object.assign(value, data)
            }
            console.log('fetch company data', value)
            commit('SET_SETTINGS', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async update({ commit }, model) {
        try {
            const storageCache = new StorageCache(companyKey)
            const result = await api.update(model)
            console.log('update company data', result)
            const data = result.data.success.data
            storageCache.set(data)
            commit('SET_SETTINGS', data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchConfiguration({ commit, state }, key) {
        try {
            const result = await api.fetchConfiguration(key)
            const data = result.data.success.data
            let configuration = {}
            if (data.length > 0) configuration = data[0]
            parseConfigurations({ commit, state }, configuration, key)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateConfiguration({ commit }, { key, text_value, bool_value }) {
        try {
            const result = await api.updateConfiguration({
                key,
                text_value,
                bool_value,
            })
            const configuration = result.data.success.data
            parseConfigurations({ commit, state }, configuration, key)
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteConfiguration({ dispatch }, key) {
        try {
            await api.deleteConfiguration(key)
            dispatch('fetch')
        } catch (err) {
            errorHandler(err)
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
